import { inject } from '@angular/core';
import { CanActivateFn, Route, Router } from '@angular/router';
import { AuthStore, isMemberUser } from '../auth.store';

export const authGuard: CanActivateFn = (_route, state) => {
    const store = inject(AuthStore);
    const router = inject(Router);

    if (!store.isAuthenticated()) {
        return router.createUrlTree(['/auth/login']);
    }

    const cleanUrl = state.url.split('?')[0].split('#')[0];

    if (isMemberUser(store.user()) && !_route.data['memberAccess'] && !routeAllowsMember(router.config, cleanUrl)) {
        return router.createUrlTree(['/sales-report']);
    }

    return true;
};

function routeAllowsMember(routes: Route[], cleanUrl: string): boolean {
    const normalizedUrl = cleanUrl.replace(/^\/+/, '');

    for (const route of routes) {
        if (route.path === normalizedUrl && route.data?.['memberAccess']) {
            return true;
        }

        if (route.children?.length && routeAllowsMember(route.children, cleanUrl)) {
            return true;
        }
    }

    return false;
}
